'use strict';

(function () {
  angular.module('specsguardApp')
    .service('ProjectBusinessService', ProjectBusinessService);

  ProjectBusinessService.$inject = ['$filter', 'Constants', 'Labels', 'sgGeneralHelpers', 'BasicAreaStore', 'AreaStore', 'BuildingStore'];

  function ProjectBusinessService ($filter, Constants, Labels, sgGeneralHelpers, basicAreaStore, areaStore, buildingStore) {

    // TODO refactor _find to sgGeneralHelpers.findById
    function _find (array, id) {
      const result = $filter('filter')(array, { _id: id});
      if (result.length > 0) {
        return result[0];
      }

      return null;
    };

    /**
     * @function findElementById
     * @param project {object}
     * @param [moduleId] {string}
     * @param [submoduleId] {string}
     * @param [elementId] {string}
     * @return {object} - The element (or null)
     * */
    this.findElementById = function (project, moduleId, submoduleId, elementId) {
      const submodule = this.findSubModuleById(project, moduleId, submoduleId);
      return _find(submodule.elements, elementId);
    };

    /**
     * @function findElementById
     * @param project {object}
     * @param location {Object} - a getElementLocation object
     * @return {object} - The element (or null)
     * */
    this.findElementByLocation = function (project, location) {
      const submodule = this.findSubModuleById(
        project,
        location.element.moduleId,
        location.element.submoduleId
      );
      return _find(submodule.elements, location.element.elementId);
    };

    /**
     * @function findModuleById
     * @param project {object}
     * @param [moduleId] {string}
     * @return {object} - The module (or null)
     * */
    this.findModuleById = function (project, moduleId) {
      return _find(project.modules, moduleId);
    };

    this.findModuleBySubmoduleId = (project, submoduleId) =>
      project.modules.find((module) =>
        module.submodules.findIndex((submodule) =>
          submodule._id === submoduleId) !== -1
      );

    /**
     * @function findSubModuleById
     * @param project {object}
     * @param [moduleId] {string}
     * @param [submoduleId] {string}
     * @return {object} - The module (or null)
     * */
    this.findSubModuleById = function (project, moduleId, submoduleId) {
      const module = this.findModuleById(project, moduleId);
      return _find(module.submodules, submoduleId);
    };

    /**
     * @function getElementLocation - generate a location object for the element
     * @param project {object}
     * @param element {object}
     * @return {object} - object containing projectId, versionId, moduleId,
     * submoduleId and elementId.
     * */
    this.getElementLocation = function (project, element) {
      return {
        _id: project._id,
        versionId: project.versionId,
        element: {
          elementId: element._id,
          moduleId: element.moduleId,
          submoduleId: element.submoduleId,
        }
      };
    };

    /**
     * @function getElements - generate a flat array of all project elements
     * @param project {Object}
     * @return {Array}
     * */
    this.getElements = function getElements (project) {
      return project.modules
        .reduce((array, module) => array.concat(module.submodules), [])
        .reduce((array, submodule) => array.concat(submodule.elements), [])
        .filter((element) => element.active);
    };

    this.getProjectUsers = (project, addUnassignedUser) => {
      const users = project.users.map((user) => {
        user._id = user.userId._id;
        user.name = user.userId.fullName;

        return user;
      });

      if (addUnassignedUser) {
        users.push({
          _id: -1,
          name: `[${Labels.getLabel('notassigned')}]`,
          userId: {
            fullName: Labels.getLabel('notassigned')
          }
        });
      }

      return users;
    };

    this.getArea = function (project, buildingId, areaId) {
      const building = project.buildings.find((b) => b._id === buildingId);

      if (!building) {
        return null;
      }
      const cluster = this.getCluster(building, areaId);

      if (cluster.length === 0) {
        return null;
      }

      const area = cluster.areas.find((a) => a._id === areaId);
      area.clusterId = cluster._id;
      return area;
    };

    this.getCluster = (building, areaId) => {
      const cluster = building.clusters.filter((clstr) => {
        return clstr.areas.findIndex((area) => area._id === areaId) > -1;
      });

      return cluster[0];
    };

    /**
     * @function getProjectImages
     * @description Returns an array of all images uploaded to the top-level project
     * @param {Object} project
     * @returns {Array}
     *
     * TODO option to also (or only) retrieve elements
     * */
    this.getProjectImages = (project) =>
      project.uploads.filter((upload) => {
        if (!upload.file.type.includes('image/')) {
          return false;
        }

        upload.uriEncodedPath = encodeURI(upload.path);
        return upload;
      });

    this.getOrderedArray = sgGeneralHelpers.getOrderedArray;
  }
})();
